module.exports = __webpack_public_path__ + "static/media/nature.e5d85002.jpg";